import SEO from "@/components/common/SEO";
import PageHeader from "@/components/shared/PageHeader";
import { Reveal, Icon } from "@/components/common/motion";
import { ContactCTA } from "@/components/shared/blocks";
import { industries } from "@/data/site";

export default function Industries() {
  return (
    <>
      <SEO title="Industries" description="Deep domain expertise across healthcare, finance, retail, manufacturing, education, logistics, telecom and more." path="/industries" />
      <PageHeader
        overline="Industries"
        title="Domain expertise where it matters most"
        subtitle="We combine engineering depth with real industry knowledge to solve complex, regulated and fast-moving challenges."
      />

      <section className="py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {industries.map((ind, i) => (
              <Reveal key={ind.name} delay={(i % 3) * 0.05}>
                <div className="group h-full overflow-hidden rounded-2xl border border-border bg-card p-7 transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg" data-testid={`industry-detail-${ind.name.toLowerCase()}`}>
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-accent/10 text-accent transition-colors group-hover:bg-accent group-hover:text-accent-foreground">
                    <Icon name={ind.icon} className="h-6 w-6" />
                  </span>
                  <h3 className="mt-5 font-display text-xl font-medium">{ind.name}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{ind.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
